import { Directions } from "./global.constants";

export const systemConstants = {
  DIRECTION_LEFT_TO_RIGHT: Directions.ltr,
  DIRECTION_RIGHT_TO_LEFT: Directions.rtl,
  TOGGLE_SAILOR_PROFILE: "TOGGLE_SAILOR_PROFILE",
  MOBILE_DETECTION: "MOBILE_DETECTION",
  RESIZE:"resize",
  LANGUAGE: localStorage.getItem("i18nextLng")
};
